const PARAGRAPH_SMALL_PROMOTION = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
     ... on BlocksCarousel {
        id
        heading
        icon
        smallPromotionBlocks {
           id
           blockBackground
           heading
           isNew
           link
           uuid
        }
        type
        uuid
     }
  }
`;

export default PARAGRAPH_SMALL_PROMOTION;
